import { FxmsData } from "../../../fxms/datas/FxData";

/**
 * @description VUP 회사 대시보드 API 항목
 * @author seoeunPark
 * @date 06/12/2023
 */

/**
 * @description 알림 API
 * @author seoeunPark
 * @date 06/12/2023
 * @param {inloNo : "11000"}
 * @return 알림 list
 */
export const vupCompanyDash10001 = async (params) => {
  const response = await FxmsData.GET("fxAlAlarm/cur/list", params);
  return response.data;
};

/**
 * @description 통신 현황 & 계측기 현황
 * @author seoeunPark
 * @date 06/12/2023
 * @param {
 *  complexInloNo : "",
 *  companyInloNo:"",
 *  plantInloNo:""
 * }
 * @return 통신 현황 & 계측기 현황 list
 */
export const vupCompanyDash10002 = async (params) => {
  const response = await FxmsData.GET("vup/dash/sensor/state", params);
  return response.data;
};

/**
 * @description 월간에너지 사용금액 & 월간에너지 사용량
 * @author seoeunPark
 * @date 06/12/2023
 * @param {
 *  complexInloNo :"",
 *  plantInloNo:"",
 *  month:""
 * }
 * @return 월간에너지 사용금액 & 월간에너지 사용량 list
 */
export const vupCompanyDash10003 = async (params) => {
  const response = await FxmsData.GET("vup/dash/energy/amount", params);
  return response.data;
};

/**
 * @description 실시간 전력 사용 현황
 * @author seoeunPark
 * @date 06/12/2023
 * @param {
 *  complexInloNo:"",
 *  companyInloNo:"",
 *  plantInloNo:"",
 *  engId:"", EPWR
 *  startDate:"",
 *  endDate:""
 * }
 * @return 실시간 전력 사용 현황List
 */
export const vupCompanyDash10004 = async (params) => {
  const response = await FxmsData.GET("vup/dash/energy/list", params);
  return response.data;
};

/**
 * @description 한전 15분 전력 사용량
 * @author dsp
 * @date 2024-11-28
 * @param {
 *  complexInloNo:"",
 *  companyInloNo:"",
 *  plantInloNo:"",
 *  startDate:"",
 *  endDate:""
 * }
 * @return 15분 전력 사용량 List
 */
export const vupCompanyDashKepcoEpwr = async (params) => {
  const response = await FxmsData.GET("vup/dash/energy/kepco", params);
  return response.data;
};
